import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  inheritAttrs: false,
};

interface Emits {
  (e: 'input', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InfoModal',
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', data: any): void;
}), expose: any, slots: any, attrs: any }) {



const onChangeValue = (value: boolean) => {
  emit('input', value);
};

return { __sfc: true,emit, onChangeValue }
}

})